import { PropsOf } from "@emotion/react"
import { Slide, Dialog, AppBar, Toolbar, IconButton, Typography, Button } from "@mui/material"
import { TransitionProps } from "@mui/material/transitions"
import { forwardRef, Ref } from "react"
import CloseIcon from '@mui/icons-material/Close'

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement
  },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

export interface ZapierCreateZapModalProps extends PropsOf<typeof Dialog> {
  url: string
  close: () => void
}

export function ZapierCreateZapModal({ url, close, ...dialogProps }: ZapierCreateZapModalProps) {
  if (!url) return null
  return (
    <Dialog fullScreen TransitionComponent={Transition} {...dialogProps}>
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={close} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Create or edit your Zap
          </Typography>
          <Button autoFocus color="inherit" onClick={close}>
            Close
          </Button>
        </Toolbar>
      </AppBar>
      <iframe
        referrerPolicy="origin"
        title="Create or edit your Zap"
        src={url}
        style={{
          display: 'flex',
          boxSizing: 'border-box',
          flex: '1 1 auto',
          flexDirection: 'column',
          gap: 'calc(4 * var(--zapier-grid-unit))',
          fontWeight: '600',
          height: '100%',
          width: '100%',
          border: '0px',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'rgb(255, 253, 249)',
          color: 'rgb(45, 46, 46)',
          fontSize: 'var(--zapier-font-size-20px)',
        }}
      ></iframe>
    </Dialog>
  )
}
